import { compose } from 'redux'
import { lifecycle, withHandlers, withState } from 'recompose'
import withType from 'components/common/hoc/withType'
import { isEqual } from 'lodash'
import OneColumnGaragePage from './OneColumnGaragePage'

const withCartridgesMapState = withState('cartridgesMap', 'setCartridgesMap', {})

const withCartridgesMapsHandlers = withHandlers({
  buildCartridgesMap: ({ placeholders: { mainGarageContent }, setCartridgesMap }) => () => {
    const cartridgesMap = {}
    mainGarageContent.forEach(item => {
      if (Array.isArray(item) && item.length > 0) {
        if (typeof item[0] === 'object' && item[0].props && item[0].props.type) {
          cartridgesMap[item[0].props.type] = item[0]
        }
      } else if (typeof item === 'object' && item.props && item.props.type) {
        cartridgesMap[item.props.type] = item
      }
    })
    setCartridgesMap(cartridgesMap)
  }
})

const withAppointmentInfoLifecycle = lifecycle({
  componentDidMount() {
    const { buildCartridgesMap, placeholders: { mainGarageContent }} = this.props
    buildCartridgesMap(mainGarageContent)
  },
  componentDidUpdate({ placeholders: { mainGarageContent: prevMainGarageContent }}) {
    const { placeholders: { mainGarageContent }, buildCartridgesMap } = this.props

    if (!isEqual(prevMainGarageContent, mainGarageContent)) {
      buildCartridgesMap(mainGarageContent)
    }
  }
})

export default compose(
  withType({ type: 'OneColumnGaragePage', placeholders: ['footer', 'header', 'mainGarageContent']}),
  withCartridgesMapState,
  withCartridgesMapsHandlers,
  withAppointmentInfoLifecycle
)(OneColumnGaragePage)
